import React from "react";
//#region react
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region components
import Routes from "routing";
import { FloatingMessageProvider } from "components/common";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "components/error";
import { StatusMessage } from "components/login";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
//#endregion
//#region intl
import { RawIntlProvider } from "react-intl";
import svLocale from "date-fns/locale/sv";
import { registerLocale, setDefaultLocale } from "react-datepicker";
//#endregion
import { pdfjs } from "react-pdf";

registerLocale("sv", svLocale);
setDefaultLocale("sv");

pdfjs.GlobalWorkerOptions.workerSrc = `${import.meta.env.BASE_URL}pdf.worker.min.mjs`;

const App: React.FC = () => {
  const locale = useSelector(
    (store: AppState) => store.common.locale,
    (left, right) => left.language === right.language
  );

  return (
    <ErrorBoundary>
      <DndProvider backend={HTML5Backend}>
        <BrowserRouter>
          <FloatingMessageProvider isGlobal>
            <StatusMessage />
            <RawIntlProvider value={locale.intl}>
              <Routes />
            </RawIntlProvider>
          </FloatingMessageProvider>
        </BrowserRouter>
      </DndProvider>
    </ErrorBoundary>
  );
};

export default React.memo(App);
